import React, { useMemo, useState } from 'react';
import {
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Pagination,
  Row,
  Table
} from 'react-bootstrap';

const ApiPartnerLedger = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 4;
  const [searchQuery, setSearchQuery] = useState('');

  const ledgerEntries = [
    {
      id: 'APL001',
      dateTime: '2025-11-07 07:45 PM',
      orderId: 'ORD-775429',
      service: 'Bulk Recharge',
      requestId: 'REQ-20251107-908',
      mobile: '9876543210',
      details: 'Settlement received for bulk recharge batch #BR-5482',
      mode: 'Settlement',
      type: 'Credit',
      amount: 250000.0,
      charges: 0,
      commission: 4500.0,
      tds: 450.0,
      balance: 680540.0,
      status: 'Settled',
      utr: 'UTR548200987'
    },
    {
      id: 'APL002',
      dateTime: '2025-11-07 09:32 AM',
      orderId: 'ORD-775114',
      service: 'Recharge API',
      requestId: 'REQ-20251107-223',
      mobile: '9988776655',
      details: 'API usage reconciliation - Recharge suite (01 Nov - 06 Nov)',
      mode: 'Auto Debit',
      type: 'Debit',
      amount: 86400.0,
      charges: 0,
      commission: 0,
      tds: 0,
      balance: 430540.0,
      status: 'Settled',
      utr: 'UTR223440198'
    },
    {
      id: 'APL003',
      dateTime: '2025-11-06 05:08 PM',
      orderId: 'ORD-774901',
      service: 'Commission',
      requestId: 'REQ-20251106-148',
      mobile: '9023456712',
      details: 'Monthly commission payout for October 2025',
      mode: 'NEFT',
      type: 'Credit',
      amount: 148300.0,
      charges: 0,
      commission: 0,
      tds: 742.0,
      balance: 516940.0,
      status: 'Settled',
      utr: 'UTR148300742'
    },
    {
      id: 'APL004',
      dateTime: '2025-11-05 11:55 AM',
      orderId: 'ORD-774440',
      service: 'Webhook',
      requestId: 'REQ-20251105-054',
      mobile: '9191919191',
      details: 'Webhook failure chargeback for customer UAT-2204',
      mode: 'Adjustment',
      type: 'Debit',
      amount: 3500.0,
      charges: 0,
      commission: 0,
      tds: 0,
      balance: 368640.0,
      status: 'Pending',
      utr: 'OPR-WHK-054'
    },
    {
      id: 'APL005',
      dateTime: '2025-11-04 08:22 PM',
      orderId: 'ORD-774215',
      service: 'Reversal',
      requestId: 'REQ-20251104-318',
      mobile: '9350011223',
      details: 'Reversal for duplicate debit API-20251031-667',
      mode: 'RTGS',
      type: 'Credit',
      amount: 22000.0,
      charges: 0,
      commission: 0,
      tds: 0,
      balance: 372140.0,
      status: 'Settled',
      utr: 'UTR372140667'
    },
    {
      id: 'APL006',
      dateTime: '2025-11-03 04:40 PM',
      orderId: 'ORD-773989',
      service: 'Settlement',
      requestId: 'REQ-20251103-227',
      mobile: '9001122334',
      details: 'Settlement transfer to master distributor MD-772',
      mode: 'Manual',
      type: 'Debit',
      amount: 125000.0,
      charges: 0,
      commission: 0,
      tds: 0,
      balance: 350140.0,
      status: 'Settled',
      utr: 'UTR125000772'
    },
    {
      id: 'APL007',
      dateTime: '2025-11-03 10:24 AM',
      orderId: 'ORD-773812',
      service: 'UPI',
      requestId: 'REQ-20251103-441',
      mobile: '9887766554',
      details: 'UPI payout fees reimbursement (Aggregator plan)',
      mode: 'UPI',
      type: 'Credit',
      amount: 1250.0,
      charges: 0,
      commission: 0,
      tds: 62.0,
      balance: 475140.0,
      status: 'Settled',
      utr: 'UTRUPI441125'
    },
    {
      id: 'APL008',
      dateTime: '2025-11-02 09:18 PM',
      orderId: 'ORD-773540',
      service: 'Dispute',
      requestId: 'REQ-20251102-019',
      mobile: '9776600112',
      details: 'Dispute hold for transaction TXN-334118 (pending resolution)',
      mode: 'Hold',
      type: 'Debit',
      amount: 18000.0,
      charges: 0,
      commission: 0,
      tds: 0,
      balance: 473890.0,
      status: 'On Hold',
      utr: 'DSP-334118'
    },
    {
      id: 'APL009',
      dateTime: '2025-11-01 06:05 PM',
      orderId: 'ORD-773221',
      service: 'Incentive',
      requestId: 'REQ-20251101-075',
      mobile: '9556612345',
      details: 'API uptime incentive for October 2025',
      mode: 'Automated',
      type: 'Credit',
      amount: 9800.0,
      charges: 0,
      commission: 0,
      tds: 490.0,
      balance: 491890.0,
      status: 'Settled',
      utr: 'UTR980075'
    },
    {
      id: 'APL010',
      dateTime: '2025-11-01 01:12 PM',
      orderId: 'ORD-773075',
      service: 'Subscription',
      requestId: 'REQ-20251101-201',
      mobile: '9000076543',
      details: 'Monthly subscription renewal for Prime API Suite',
      mode: 'Auto Debit',
      type: 'Debit',
      amount: 4999.0,
      charges: 99.0,
      commission: 0,
      tds: 0,
      balance: 482090.0,
      status: 'Settled',
      utr: 'UTR4999201'
    },
    {
      id: 'APL011',
      dateTime: '2025-10-31 08:47 PM',
      orderId: 'ORD-772844',
      service: 'Settlement',
      requestId: 'REQ-20251031-884',
      mobile: '9011223344',
      details: 'Bulk settlement for retail payout batch #RTP-884',
      mode: 'RTGS',
      type: 'Credit',
      amount: 175000.0,
      charges: 0,
      commission: 3500.0,
      tds: 175.0,
      balance: 487089.0,
      status: 'Settled',
      utr: 'UTR8843500'
    },
    {
      id: 'APL012',
      dateTime: '2025-10-31 03:15 PM',
      orderId: 'ORD-772603',
      service: 'Webhook',
      requestId: 'REQ-20251031-311',
      mobile: '9122334455',
      details: 'Chargeback for failed webhook retry cycle',
      mode: 'Adjustment',
      type: 'Debit',
      amount: 2750.0,
      charges: 0,
      commission: 0,
      tds: 0,
      balance: 312089.0,
      status: 'Settled',
      utr: 'OPR-WHK-311'
    },
    {
      id: 'APL013',
      dateTime: '2025-10-30 11:50 AM',
      orderId: 'ORD-772210',
      service: 'Credit Note',
      requestId: 'REQ-20251030-099',
      mobile: '9988007766',
      details: '24Pay API sandbox maintenance credit',
      mode: 'Manual',
      type: 'Credit',
      amount: 2500.0,
      charges: 0,
      commission: 0,
      tds: 125.0,
      balance: 314839.0,
      status: 'Settled',
      utr: 'UTR24PAY099'
    },
    {
      id: 'APL014',
      dateTime: '2025-10-29 07:05 PM',
      orderId: 'ORD-771998',
      service: 'Adjustment',
      requestId: 'REQ-20251029-021',
      mobile: '9445566778',
      details: 'Manual adjustment for reconciliation mismatch',
      mode: 'Manual',
      type: 'Debit',
      amount: 12500.0,
      charges: 0,
      commission: 0,
      tds: 0,
      balance: 312339.0,
      status: 'Settled',
      utr: 'UTR12500-021'
    },
    {
      id: 'APL015',
      dateTime: '2025-10-28 02:18 PM',
      orderId: 'ORD-771664',
      service: 'Incentive',
      requestId: 'REQ-20251028-557',
      mobile: '9332211009',
      details: 'Performance incentive on onboarding 5 new distributors',
      mode: 'NEFT',
      type: 'Credit',
      amount: 45000.0,
      charges: 0,
      commission: 0,
      tds: 2250.0,
      balance: 324839.0,
      status: 'Settled',
      utr: 'UTR5574500'
    }
  ];

  const filteredEntries = useMemo(() => {
    if (!searchQuery) {
      return ledgerEntries;
    }

    return ledgerEntries.filter((entry) =>
      Object.values(entry).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [ledgerEntries, searchQuery]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentEntries = filteredEntries.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredEntries.length / rowsPerPage) || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatCurrency = (value) => (value ? `₹${value.toFixed(2)}` : '-');

  const formatSignedAmount = (value, type) => {
    if (!value) {
      return '-';
    }

    const formatted = `₹${value.toFixed(2)}`;
    return type === 'Credit' ? `+${formatted}` : `-${formatted}`;
  };

  const getPaginationItems = () => {
    const items = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        items.push(
          <Pagination.Item
            key={i}
            active={i === currentPage}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      } else if (currentPage >= totalPages - 2) {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = totalPages - 3; i <= totalPages; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
      } else {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      }
    }

    return items;
  };

  return (
    <Container fluid className="ledger-reports-page p-4">
      <Row>
        <Col>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>
                    Ledger
                  </h5>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <InputGroup style={{ maxWidth: '300px' }}>
                    <InputGroup.Text style={{ backgroundColor: '#f8f9fa', border: '1px solid #ddd' }}>
                      <i className="bi bi-search"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                      style={{ border: '1px solid #ddd' }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      {[
                        'ID',
                        'Date_&_Time',
                        'Order_ID',
                        'Service',
                        'request_id',
                        'Mobile',
                        'Details',
                        'Mode',
                        'Cr / Dr',
                        'Amount',
                        'Charges',
                        'Commission',
                        'TDS',
                        'Balance',
                        'Status',
                        'UTR_/_Operator_ID'
                      ].map((column) => (
                        <th
                          key={column}
                          style={{
                            padding: '12px 16px',
                            fontWeight: 600,
                            color: '#555',
                            borderBottom: '2px solid #dee2e6',
                            fontSize: '13px'
                          }}
                        >
                          {column}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {currentEntries.length > 0 ? (
                      currentEntries.map((entry) => (
                        <tr key={entry.id} style={{ transition: 'background-color 0.2s' }}>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>{entry.id}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{entry.dateTime}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px', fontFamily: 'monospace' }}>{entry.orderId}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px' }}>{entry.service}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px', fontFamily: 'monospace' }}>{entry.requestId}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px' }}>{entry.mobile}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', maxWidth: '220px' }}>
                            <details>
                              <summary style={{ cursor: 'pointer', fontWeight: 500 }}>
                                View
                              </summary>
                              <div style={{ marginTop: '8px', color: '#555', fontSize: '12px' }}>{entry.details}</div>
                            </details>
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{entry.mode}</td>
                          <td style={{ padding: '12px 16px' }}>
                            <span
                              className={`badge rounded-pill ${
                                entry.type === 'Credit' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'
                              }`}
                              style={{ fontSize: '11px' }}
                            >
                              {entry.type}
                            </span>
                          </td>
                          <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: 600, color: entry.type === 'Credit' ? '#198754' : '#dc3545' }}>
                            {formatSignedAmount(entry.amount, entry.type)}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{formatCurrency(entry.charges)}</td>
                          <td style={{ padding: '12px 16px', color: '#198754', fontSize: '13px', fontWeight: 600 }}>{formatCurrency(entry.commission)}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{formatCurrency(entry.tds)}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>{formatCurrency(entry.balance)}</td>
                          <td style={{ padding: '12px 16px', color: entry.status === 'Settled' ? '#198754' : entry.status === 'Pending' ? '#fd7e14' : '#0d6efd', fontSize: '13px' }}>
                            {entry.status}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px', fontFamily: 'monospace' }}>{entry.utr}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={12} className="text-center py-4" style={{ color: '#999' }}>
                          No ledger entries found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
            <Card.Footer className="bg-white border-top" style={{ padding: '12px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    Showing {filteredEntries.length === 0 ? 0 : indexOfFirstRow + 1} to {Math.min(indexOfLastRow, filteredEntries.length)} of {filteredEntries.length}
                  </div>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <Pagination className="mb-0">
                    <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                    <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                    {getPaginationItems()}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageChange(totalPages)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
        </Col>
      </Row>

      <style jsx="true">{`
        .ledger-reports-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .pagination .page-link {
          color: #0d6efd;
          border: 1px solid #dee2e6;
          padding: 6px 12px;
          font-size: 14px;
        }

        .pagination .page-item.active .page-link {
          background-color: #0d6efd;
          border-color: #0d6efd;
          color: white;
        }

        .pagination .page-link:hover {
          background-color: #e7f1ff;
          border-color: #0d6efd;
          color: #0d6efd;
        }

        .pagination .page-item.disabled .page-link {
          color: #6c757d;
          pointer-events: none;
          background-color: #fff;
          border-color: #dee2e6;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }

          .pagination {
            font-size: 12px;
          }
        }
      `}</style>
    </Container>
  );
};

export default ApiPartnerLedger;


